import hsylog from '@assets/img/smarax-log.png'
// import fptpluslog from '@assets/img/new-fpt-logo.png'
// import fptpluslog from '@assets/img/fpt-logo.png'
// import fapiaocnlog from '@assets/img/fapiaocn-logo.png'
// import fapiaocncomlog from '@assets/img/logo-1.png'
// import jcsk100 from '@assets/img/jcsk100-logo.png'
// import gfwuhs from '@assets/img/gfwuhs.png'
// import fapiaocn from '@assets/img/fapiao-cn.png'

import dz from '@/assets/img/dianzhuan.png'
import dp from '@/assets/img/dianpu.png'
import sdz from '@/assets/img/shudianzhuan.png'
import sdp from '@/assets/img/shudianpu.png'

import pdf from '@assets/img/pdf.png'
import ofd from '@assets/img/ofd.png'
import bigPdf from '@assets/img/big-pdf.png'
import bigOfd from '@assets/img/big-ofd.png'
import kpz from '@assets/img/kpz.png'

export const taxControlRedReason = {
  '1': '销售退回',
  '2': '开票有误',
  '3': '服务中止',
  '4': '销售销售折让退回'
}
export const allElectricRedReason = {
  '03': '开票有误',
  '04': '销货退回',
  '05': '销售折让',
  '06': '应税服务中止'
}

export const INVOICE_STATUS = [
  {
    title: '未开具',
    value: 0
  },
  {
    title: '开票异常',
    value: 1
  },
  {
    title: '开票驳回',
    value: 2
  },
  {
    title: '待确认',
    value: 3
  },
  {
    title: '未寄送',
    value: 4
  }
]

export const INVOICE_TYPE_IMG_AND_NAME_MAP = [
  { name: '增值税普通发票(电子)', value: 3, url: dp, color: 'success', abbr: '电子普票' },
  { name: '增值税专用发票(电子)', value: 4, url: dz, color: 'primary', abbr: '电子专票' },
  { name: '数电普通发票', value: 7, url: sdp, color: 'success', abbr: '数电普票' },
  { name: '数电专用发票', value: 8, url: sdz, color: 'primary', abbr: '数电专票' }
]

export const APPLY_INVOICE_STATUS = [
  {
    title: '未开具',
    value: 0
  },
  {
    title: '未开具',
    value: 1
  },
  {
    title: '开票异常',
    value: 4
  },
  {
    title: '开票中',
    value: 2
  },
  {
    title: '开票成功',
    value: 3
  }
]

export const STAT_INVOICE_STATUS = [
  {
    title: '红冲',
    value: 20,
    color: 'rgb(236, 84, 122)'
  },
  {
    title: '正常',
    value: 10,
    color: 'rgb(191, 191, 191)'
  },
  {
    title: '作废',
    value: 30,
    color: 'rgb(191, 191, 191)'
  }
]

export const INVOICE_TYPE_FOR_CARD_INCOME = [
  {
    title: '专票',
    value: '01'
  },
  {
    title: '普票',
    value: '04'
  },
  {
    title: '电普',
    value: '10'
  },
  {
    title: '电专',
    value: '08'
  },
  {
    title: '卷票',
    value: '11'
  },
  {
    title: '定额',
    value: '200'
  },
  {
    title: '火车',
    value: '201'
  },
  {
    title: '飞机',
    value: '202'
  },
  {
    title: '出租',
    value: '207'
  },
  {
    title: '数电专票',
    value: '8'
  },
  {
    title: '数电普票',
    value: '7'
  },
  {
    title: '数电专票',
    value: 8
  },
  {
    title: '数电普票',
    value: 7
  }
]

export const INVOICE_TYPE = [
  {
    title: '专票',
    value: '1'
  },
  {
    title: '普票',
    value: '2'
  },
  {
    title: '电子普票',
    value: '3'
  },
  {
    title: '电子专票',
    value: '4'
  },
  {
    title: '数电专票',
    value: '8'
  },
  {
    title: '数电普票',
    value: '7'
  },
  {
    title: '数电专票',
    value: 8
  },
  {
    title: '数电普票',
    value: 7
  }
]

export const INVOICE_TYPE_FOR_CARD = [
  {
    title: '专票',
    value: 1
  },
  {
    title: '普票',
    value: 2
  },
  {
    title: '电普',
    value: 3
  },
  {
    title: '电专',
    value: 4
  },
  {
    title: '机动车',
    value: 5
  },
  {
    title: '专票',
    value: 10
  },
  {
    title: '普票',
    value: 20
  },
  {
    title: '电票',
    value: 30
  },
  {
    title: '数电专票',
    value: 8
  },
  {
    title: '数电普票',
    value: 7
  }
]

export const APPLICATION_INVOICE_TYPE_LIST = [
  // {
  //   title: '专票',
  //   index: 1
  // },
  // {
  //   title: '普票',
  //   index: 2
  // },
  // {
  //   title: '电专',
  //   index: 4
  // },
  // {
  //   title: '电普',
  //   index: 3
  // },
  {
    title: '数电专',
    index: 8
  },
  {
    title: '数电普',
    index: 7
  }
]

export const APPLY_TYPE = [
  {
    title: '模板导入',
    index: '1'
  },
  {
    title: '手动录入',
    index: '2'
  }
]

export const INVOICE_METHOD = [
  {
    title: '自有税盘',
    value: 0
  },
  {
    title: '税局代开',
    value: 1
  }
]

export const GET_TYPE = [
  {
    title: '快递寄送',
    value: '1'
  },
  {
    title: '客户自取',
    value: '0'
  },
  {
    title: '',
    value: 'undefined'
  }
]

export const TOOLS_TYPE = [
  {
    title: '金税盘',
    value: 0
  },
  {
    title: '税控盘',
    value: 1
  },
  {
    title: '税务Ukey',
    value: 2
  },
  {
    title: '税控服务器',
    value: 3
  }
]

export const TAX_RATE = [
  {
    title: '0%',
    value: 0
  },
  {
    title: '1%',
    value: 0.01
  },
  {
    title: '3%',
    value: 0.03
  },
  {
    title: '5%',
    value: 0.05
  },
  {
    title: '6%',
    value: 0.06
  },
  {
    title: '9%',
    value: 0.09
  },
  {
    title: '10%',
    value: 0.1
  },
  {
    title: '11%',
    value: 0.11
  },
  {
    title: '13%',
    value: 0.13
  },
  {
    title: '16%',
    value: 0.16
  },
  {
    title: '17%',
    value: 0.17
  }
]

export const TAX_SIGN = [
  {
    title: '含税',
    value: 1
  },
  {
    title: '不含税',
    value: 0
  }
]
export const TAX_PRE = [
  {
    title: '是',
    value: 0
  },
  {
    title: '否',
    value: 1
  }
]

export const TAX_SPECIAL_TYPE = {
  '01': '简易征收',
  '02': '稀土产品',
  '03': '免税',
  '04': '不征税',
  '05': '先征后退',
  '06': '100%先征后退',
  '07': '50%先征后退',
  '08': '按3%简易征收',
  '09': '按5%简易征收',
  '10': '按5%简易征收减按1.5%计征',
  '11': '即征即退30%',
  '12': '即征即退50%',
  '13': '即征即退70%',
  '14': '即征即退100%',
  '15': '超税负3%即征即退',
  '16': '超税负8%即征即退',
  '17': '超税负12%即征即退',
  '18': '超税负6%即征即退'
}

export const getTaxSpecialType = (arr) => {
  const typeList = []
  const map = new Map()
  map.set('01', '简易征收')
  map.set('02', '稀土产品')
  map.set('03', '免税')
  map.set('04', '不征税')
  map.set('05', '先征后退')
  map.set('06', '100%先征后退')
  map.set('07', '50%先征后退')
  map.set('08', '按3%简易征收')
  map.set('09', '按5%简易征收')
  map.set('10', '按5%简易征收减按1.5%计征')
  map.set('11', '即征即退30%')
  map.set('12', '即征即退50%')
  map.set('13', '即征即退70%')
  map.set('14', '即征即退100%')
  map.set('15', '超税负3%即征即退')
  map.set('16', '超税负8%即征即退')
  map.set('17', '超税负12%即征即退')
  map.set('18', '超税负6%即征即退')
  if (arr) {
    arr.forEach(i => {
      typeList.push({ value: i, title: TAX_SPECIAL_TYPE[i] })
    })
  } else {
    Array.from(map.keys()).forEach(i => {
      typeList.push({ value: i, title: map.get(i) })
    })
  }
  console.log(typeList)
  return typeList
}

export const TAX_PRE_TYPE = [
  { value: 0, title: '普通零税率' },
  { value: 1, title: '免税' },
  { value: 2, title: '不征税' },
  { value: 0, title: '正常税率' }
]

export const EXPRESS_STATUS = [
  {
    title: '已签收',
    value: 0,
    icon: '\ue69d'
  },
  {
    title: '派送中',
    value: 1,
    icon: '\ue690'
  },
  {
    title: '运输中',
    value: 2,
    icon: '\ue69e'
  },
  {
    title: '已揽件',
    value: 3,
    icon: '\ue6a2'
  },
  {
    title: '已发货',
    value: 4,
    icon: '\ue69f'
  }
]

export const CHECK_JURISDICTION_URL_LIST = [
  '/invoice/business/open',
  '/invoice/add-apply',
  '/invoice/invoice-home',
  '/reimbursement/reimList',
  '/reimbursement/launch-reim',
  '/ticket/center/index',
  '/invoice/add-goods'
]

export const ADVERTISEMENT_PAGE = [
  '/invoice-opening/result',
  '/order/scan-invoice'
]

export const AREA_UNIT = [
  { value: '平方米', title: '平方米' },
  { value: '亩', title: '亩' },
  { value: '平方千米', title: '平方千米' },
  { value: '公顷', title: '公顷' }
]

// 出行类型
export const TYPE_OF_VEHICLE = [
  { value: '1', title: '飞机' },
  { value: '2', title: '火车' },
  { value: '3', title: '长途汽车' },
  { value: '4', title: '公共交通' },
  { value: '5', title: '出租车' },
  { value: '6', title: '汽车' },
  { value: '7', title: '船舶' },
  { value: '9', title: '其他' }
]

/**
 * @description 费用类型集合
 */
export const ExpenseTypeMap = [
  { label: '办公', value: '01' },
  { label: '餐饮', value: '02' },
  { label: '通讯', value: '03' },
  { label: '飞机', value: '04' },
  { label: '火车', value: '05' },
  { label: '巴士', value: '06' },
  { label: '打车', value: '07' },
  { label: '住宿', value: '08' },
  { label: '餐补', value: '09' },
  { label: '里程', value: '10' },
  { label: '娱乐', value: '11' },
  { label: '福利', value: '12' },
  { label: '快递', value: '13' },
  { label: '其他', value: '00' }
]

// 出行人证件类型
export const TOURISM_SERVICES_DOCUMENT_TYPE_MAP = [
  { value: '101', title: '组织机构代码证' },
  { value: '102', title: '营业执照' },
  { value: '103', title: '税务登记证' },
  { value: '199', title: '其他单位证件' },
  { value: '201', title: '居民身份证' },
  { value: '202', title: '军官证' },
  { value: '203', title: '武警警官证' },
  { value: '204', title: '士兵证' },
  { value: '205', title: '军队离退休干部证' },
  { value: '206', title: '残疾人证' },
  { value: '207', title: '残疾军人证（1-8级）' },
  { value: '208', title: '外国护照' },
  { value: '210', title: '港澳居民来往内地通行证' },
  { value: '212', title: '中华人民共和国往来港澳通行证' },
  { value: '213', title: '台湾居民来往大陆通行证' },
  { value: '214', title: '大陆居民往来台湾通行证' },
  { value: '215', title: '外国人居留证' },
  { value: '216', title: '外交官证' },
  { value: '217', title: '使（领事）馆证' },
  { value: '218', title: '海员证' },
  { value: '219', title: '香港永久性居民身份证' },
  { value: '220', title: '台湾身份证' },
  { value: '221', title: '澳门特别行政区永久性居民身份证' },
  { value: '222', title: '外国人身份证件' },
  { value: '224', title: '就业失业登记证' },
  { value: '225', title: '退休证' },
  { value: '226', title: '离休证' },
  { value: '227', title: '中国护照' },
  { value: '228', title: '城镇退役士兵自谋职业证' },
  { value: '229', title: '随军家属身份证明' },
  { value: '230', title: '中国人民解放军军官转业证书' },
  { value: '231', title: '中国人民解放军义务兵退出现役证' },
  { value: '232', title: '中国人民解放军士官退出现役证' },
  { value: '233', title: '外国人永久居留身份证（外国人永久居留证）' },
  { value: '235', title: '香港特别行政区护照' },
  { value: '236', title: '澳门特别行政区护照' },
  { value: '237', title: '中华人民共和国港澳居民居住证' },
  { value: '238', title: '中华人民共和国台湾居民居住证' },
  { value: '239', title: '《中华人民共和国外国人工作许可证》（A类）' },
  { value: '240', title: '《中华人民共和国外国人工作许可证》（B类）' },
  { value: '241', title: '《中华人民共和国外国人工作许可证》（C类）' },
  { value: '291', title: '医学出生证明' },
  { value: '299', title: '其他个人证件' }
]

export const TAX_PLATE_TYPE = [
  {
    title: '金税盘（航天信息）',
    value: 0
  },
  {
    title: '税控盘（百旺金赋）',
    value: 1
  },
  {
    title: '税务（UKEY）',
    value: 2
  }
]

export const WHETHER_OR_NOT = [
  {
    title: '是',
    value: 'Y'
  },
  {
    title: '否',
    value: 'N'
  }
]

export const FINISHED_OIL = [
  {
    title: '升',
    value: '升'
  },
  {
    title: '吨',
    value: '吨'
  }
]

// 出行类型对应的等级
export const TRAVEL_LEVEL_MAP = {
  '1': [
    { value: '经济舱', title: '经济舱' },
    { value: '头等舱', title: '头等舱' },
    { value: '公务舱', title: '公务舱' }
  ],
  '2': [
    { value: '一等座', title: '一等座' },
    { value: '二等座', title: '二等座' },
    { value: '软席(软座、软卧)', title: '软席(软座、软卧)' },
    { value: '硬席(硬座、硬卧)', title: '硬席(硬座、硬卧)' }
  ],
  '7': [
    { value: '一等舱', title: '一等舱' },
    { value: '二等舱', title: '二等舱' },
    { value: '三等舱', title: '三等舱' }
  ]
}

export const TYPE_OF_TRANSPORTATION = [
  { value: '铁路运输', title: '铁路运输' },
  { value: '公路运输', title: '公路运输' },
  { value: '水路运输', title: '水路运输' },
  { value: '航空运输', title: '航空运输' },
  { value: '管道运输', title: '管道运输' },
  { value: '其他运输工具', title: '其他运输工具' }
]

export const ORDER_INVOICE_TYPE = [
  {
    title: '企业',
    value: '0'
  },
  {
    title: '个人',
    value: '1'
  },
  {
    title: '非企业',
    value: '2'
  }
]

export const LOOK_UP_ORDER_INVOICE_TYPE = [
  {
    title: '企业',
    value: '0'
  },
  {
    title: '个人/非企业',
    value: '1'
  }
]

export const SPECIFIC_BUSINESS_OPTIONS = [
  { value: '', label: '暂未选择' },
  { value: '01', label: '成品油' },
  { value: '03', label: '建筑服务' },
  { value: '04', label: '货物运输服务' },
  { value: '05', label: '不动产销售服务' },
  { value: '06', label: '不动产经营租赁服务' },
  { value: '09', label: '旅客运输服务' }
]

export const INVOICE_TYPE_MAPPING = {
  4: '电子专票直开',
  3: '电子普票直开',
  7: '数电普直开',
  8: '数电专直开'
}

export const INVOICE_STATUS_ICON = [
  {
    title: '开具成功',
    value: 'invoice-success',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/invoice-success.png',
    name: 'invoice-success'
  },
  {
    title: '部分开具',
    value: 'invoice-part',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/invoice-part.png',
    name: 'invoice-part'
  },
  {
    title: '未开具',
    value: 'invoice-uninvoice',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/invoice-uninvoice.png',
    name: 'invoice-uninvoice'
  },
  {
    title: '开票中',
    value: 'invoicing',
    url: kpz,
    name: 'invoicing'
  },
  {
    title: '开具失败',
    value: 'invoice-failed',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/invoice-failed.png',
    name: 'invoice-failed'
  },
  {
    title: '验真成功',
    value: 'invoice-checked',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/invoice-checked.png',
    name: 'invoice-checked'
  },
  {
    title: '验真失败',
    value: 'invoice-checked-failed',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/invoice-checked-failed.png',
    name: 'invoice-checked-failed'
  },
  {
    title: '未验真',
    value: 'invoice-unchecked',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/invoice-unchecked.png',
    name: 'invoice-unchecked'
  },
  {
    title: '提交报账',
    value: 'invoice-submit',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/invoice-submit.png',
    name: 'invoice-submit'
  },
  {
    title: '待寄送',
    value: 'invoice-un-send',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/invoice-un-send.png',
    name: 'invoice-un-send'
  },
  {
    title: '待签收',
    value: 'invoice-un-receive',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/invoice-un-receive.png',
    name: 'invoice-un-receive'
  },
  {
    title: '正常',
    value: 'invoice-normal',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/invoice-normal.png',
    name: 'invoice-normal'
  },
  {
    title: '红冲',
    value: 'invoice-red',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/invoice-red.png',
    name: 'invoice-red'
  },
  {
    title: '作废',
    value: 'invoice-abandon',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/invoice-abandon.png',
    name: 'invoice-abandon'
  },
  {
    title: '失控',
    value: 'invoice-out-of-control',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/invoice-out-of-control.png',
    name: 'invoice-out-of-control'
  },
  {
    title: '异常',
    value: 'invoice-error',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/invoice-error.png',
    name: 'invoice-error'
  },
  {
    title: '红字',
    value: 'output-negative-red',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/output-negative-red.png',
    name: 'output-negative-red'
  },
  {
    title: '待作废',
    value: 'to-be-cancel',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/to-be-cancel.png',
    name: 'to-be-cancel'
  },
  {
    title: '待红冲',
    value: 'to-be-red',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/to-be-red.png',
    name: 'to-be-red'
  },
  {
    title: '销项负数',
    value: 'output-negative',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/output-negative.png',
    name: 'output-negative'
  },

  {
    title: '已驳回',
    value: 'returned',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/invoice-reject.png',
    name: 'returned'
  },
  {
    title: '审批中',
    value: 'under-approval',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/invoice-approving.png',
    name: 'under-approval'
  },
  {
    title: '审批通过',
    value: 'approved',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/invoice-approved.png',
    name: 'approved'
  },
  {
    title: '部分开具',
    value: 'part',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/invoice-part.png',
    name: 'part'
  },
  {
    title: '已撤销',
    value: 'revoked',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/revoked.png',
    name: 'revoked'
  },
  {
    title: '已退回',
    value: 'invoice-return',
    url: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/bookkeeping-mobile/return.png',
    name: 'invoice-return'
  }
]

export const INVOICE_TYPE_OPTIONS = [
  { text: '全部类型', value: undefined },
  { text: '专票', value: '01' },
  { text: '普票', value: '04' },
  { text: '电子普票', value: '10' },
  { text: '电子专票', value: '08' },
  { text: '卷票', value: '11' },
  { text: '定额发票', value: '200' },
  { text: '火车票', value: '201' },
  { text: '飞机票', value: '202' },
  { text: '出租车票', value: '207' },
  { text: '数电火车票', value: '51' },
  { text: '数电飞机票', value: '61' }
]

/**
 * @description 审批状态映射
 */
export const EXAMINE_STATUS_MAP = {
  'RUNNING': '审批中',
  'FINISHED': '已完成',
  'REVOKE': '已撤回',
  'REJECT': '已驳回',
  'ABORT': '已作废'
}

/**
 * @description reimStatusMap，包含icon、颜色、文案等
 */
export const REIMSTATUSCONFIGMAP = {
  1: { text: '审批中', icon: '\ue66e', color: 'warning' },
  2: { text: '已完成', icon: '\ue66d', color: 'success' },
  3: { text: '已驳回', icon: '\ue66c', color: 'error' },
  4: { text: '已撤回', icon: '\ue66c', color: 'error' }
}

export const ENTRY_INVOICE_REIMBURSE_EXPENSETYPE = {
  '00': '其他',
  '01': '办公',
  '02': '餐饮',
  '03': '通讯',
  '04': '飞机',
  '05': '火车',
  '06': '巴士',
  '07': '打车',
  '08': '住宿',
  '09': '餐补',
  '10': '里程',
  '11': '娱乐',
  '12': '福利',
  '13': '快递'
}

export const platformConfig = {
  getName: () => {
    const systemconf = JSON.parse(localStorage.getItem('systemconf') || '{}')
    return systemconf.platformName
  },
  getCompanyName: () => {
    const systemconf = JSON.parse(localStorage.getItem('systemconf') || '{}')
    return systemconf.companyName
  },
  getCompanyShortName: () => {
    const systemconf = JSON.parse(localStorage.getItem('systemconf') || '{}')
    return systemconf.companyShortName
  },
  getContentLogo: () => {
    const systemconf = JSON.parse(localStorage.getItem('systemconf') || '{}')
    return systemconf.contentLogo || hsylog
  },
  getMobileLogo: () => {
    const systemconf = JSON.parse(localStorage.getItem('systemconf') || '{}')
    return systemconf.mobileLogo || hsylog
  },
  getIcpNo: () => {
    const systemconf = JSON.parse(localStorage.getItem('systemconf') || '{}')
    return systemconf.icpNo
  },
  getPoliceNo: () => {
    const systemconf = JSON.parse(localStorage.getItem('systemconf') || '{}')
    return {
      text: systemconf.policeNoText,
      number: systemconf.policeNoNumber
    }
  },
  getCopyRight: () => {
    const systemconf = JSON.parse(localStorage.getItem('systemconf') || '{}')
    return systemconf.copyRright
  },
  getEntryInvoiceCheckValueAddPushType: () => {
    if (window.location.host.includes('fapiaoplus.com.cn')) {
      return 1
    }
    return 0
  },
  getAllName: () => {
    const systemconf = JSON.parse(localStorage.getItem('systemconf') || '{}')
    return systemconf.platformName + '智能财税平台'
  },
  getMinioAdressUrl: () => {
    const ipConfig = JSON.parse(localStorage.getItem('ip-config-setting')) || {}
    const systemconf = JSON.parse(localStorage.getItem('systemconf') || '{}') // default.json 的优先级高于ip-config-setting
    return systemconf.minioAdressUrl || ipConfig.minioAdressUrl
  }
}

export const THUMBNAIL_CONFIG = (url) => {
  const newUrl = url || ''
  const suffix = newUrl.split('.')[newUrl.split('.').length - 1]
  let src = ''
  switch (suffix) {
    case 'pdf':
      src = pdf
      break
    case 'ofd':
      src = ofd
      break
    default:
      src = newUrl
      break
  }
  return src
}
export const BIG_THUMBNAIL_CONFIG = (url) => {
  const newUrl = url || ''
  const suffix = newUrl.split('.')[newUrl.split('.').length - 1]
  let src = ''
  switch (suffix) {
    case 'pdf':
      src = bigPdf
      break
    case 'ofd':
      src = bigOfd
      break
    default:
      src = newUrl
      break
  }
  return src
}
